import { SocietyCorporateId } from 'types/Society';

export const configsByCorporateId: Record<SocietyCorporateId, any> = {
  [SocietyCorporateId.DEFAULT]: {
    // General
    hasAdminDomainsLimited: false,
    allowedAdminEmailDomains: [],
    hasBasicBoardEntityType: false,
    hasPartnerBookEnabled: true,
    maxPartnerBookRows: 1000,
    // Secondary menu
    showProfileDataTab: true,
    showSubscriptionOption: true,
    showContactOption: true,
    showSupportOption: true,
  },
  [SocietyCorporateId.AXA]: {
    // General
    hasAdminDomainsLimited: true,
    allowedAdminEmailDomains: ['axa.es', 'sttok.com'],
    hasBasicBoardEntityType: true,
    hasPartnerBookEnabled: false,
    maxPartnerBookRows: 1000,
    // Secondary menu
    showProfileDataTab: true,
    showSubscriptionOption: false,
    showContactOption: true,
    showSupportOption: false,
  },
  [SocietyCorporateId.ASG]: {},
};
